const mock = import.meta.env.VITE_MOCK === "true";

function val(key: string, fallback: string): string {
  const v = import.meta.env[key];
  if (v) return v;
  if (mock) return fallback;
  throw new Error(`Missing env var: ${key}`);
}

export const env = {
  apiBase: val("VITE_API_BASE", "http://localhost:8787"),
  billingBase: val("VITE_BILLING_BASE", "http://localhost:8787"),
} as const;
